import React from 'react';
import {
  Button,
  Col, Layout, Menu, Row, Space, theme, Typography,
} from 'antd';
import PropTypes from 'prop-types';
import { PoweroffOutlined, SettingOutlined } from '@ant-design/icons';
import axios from 'axios';

const ApplicationHeader = ({
  userName = null,
  loggedIn = false,
  menuItems = [],
  currentMenuItem = '',
}) => {
  const handleLogout = () => {
    const csrf = document.head.querySelector("[name='csrf-token']").content;

    axios({
      headers: { 'X-CSRF-Token': csrf },
      method: 'delete',
      url: '/login',
    }).then(() => {
      document.location.href = '/login/new';
    });
  };

  return (
    <Layout>
      <Layout.Header style={{ display: 'flex', alignItems: 'center' }}>
        <div className="container">
          <Row gutter={10}>
            <Col span={4} style={{ display: 'flex', alignItems: 'center' }}>
              <Typography.Title
                level={3}
                style={{ color: 'white', margin: 0 }}
              >KCAS IT Support
              </Typography.Title>
            </Col>
            <Col span={15}>
              <Menu
                theme="dark"
                mode="horizontal"
                onClick={({ key }) => {
                  globalThis.location.href = key;
                }}
                defaultSelectedKeys={currentMenuItem}
                items={menuItems}
                style={{ flex: 1, minWidth: 0 }}
              />
            </Col>
            <Col
              span={3}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
              }}
            >
              {userName && (
                <Typography.Text style={{ color: 'white' }}>
                  {userName}
                </Typography.Text>
              )}
            </Col>
            <Col
              span={2}
              style={{ display: 'flex', alignItems: 'center' }}
            >
              {loggedIn && (
                <Space>
                  <Button
                    type="dashed"
                    shape="circle"
                    href="/settings"
                    icon={<SettingOutlined />}
                  />
                  <Button
                    type="dashed"
                    shape="circle"
                    onClick={handleLogout}
                    icon={<PoweroffOutlined />}
                  />
                </Space>
              )}
            </Col>
          </Row>
        </div>
      </Layout.Header>
    </Layout>
  );
};

ApplicationHeader.propTypes = {
  userName: PropTypes.string,
  loggedIn: PropTypes.bool,
  menuItems: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })),
  currentMenuItem: PropTypes.string,
};

export default ApplicationHeader;
